import { z } from 'zod'
const jsonObject = z.record(z.unknown())
export const trainerChannelAttachmentLifecycleResponseSchema = jsonObject
export type TrainerChannelAttachmentLifecycleResponse = z.infer<typeof trainerChannelAttachmentLifecycleResponseSchema>
